import {
  DATABASE_TABLE_ADD_COLUMN_WIDTH,
  DATABASE_TABLE_HEADER_HEIGHT,
  DATABASE_TABLE_ROW_GUTTER_WIDTH,
  DATABASE_TABLE_ROW_HEIGHT,
  DATABASE_TABLE_STATS_BAR_HEIGHT,
} from '@streamlain/database-identity/canvas-database-layout';

/** column default width */
export const DEFAULT_COLUMN_WIDTH = 180;
/** column min width */
export const DEFAULT_COLUMN_MIN_WIDTH = 100;
/** column title height */
export const DEFAULT_COLUMN_TITLE_HEIGHT = DATABASE_TABLE_HEADER_HEIGHT;
/** add-column cell width */
export const DEFAULT_ADD_BUTTON_WIDTH = DATABASE_TABLE_ADD_COLUMN_WIDTH;
export const LEFT_TOOL_BAR_WIDTH = DATABASE_TABLE_ROW_GUTTER_WIDTH;
export const STATS_BAR_HEIGHT = DATABASE_TABLE_STATS_BAR_HEIGHT;
export const TABLE_ROW_HEIGHT = DATABASE_TABLE_ROW_HEIGHT;
